import React from "react";

const Map = ({ height = "h-64 md:h-96" }) => {
    const handleMarkerClick = () => {
        window.open("https://www.google.com/maps?q=24.927417,67.041611", "_blank");
    };

    return (
        <div className={`w-full ${height} relative`}>
            <iframe
                src="https://www.google.com/maps?q=24.927417,67.041611&hl=en&z=17&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg shadow-md"
                title="Aureus Location"
            ></iframe>

            <button
                onClick={handleMarkerClick}
                className="absolute z-10 px-3 py-2 text-sm font-medium text-gray-800 transition-colors duration-200 bg-white rounded-md shadow-md top-4 right-4 hover:bg-gray-100"
            >
                Open in Google Maps
            </button>
        </div>
    );
};

export default Map;
